import * as React from 'react';
import { LoadOptions, RequestApiMethod } from 'app/types-shared';
import { CodeSinglePicker } from '../../common';
import { CodeColourProps } from './types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { endpoints } from 'app/area/codetable/item/endpoints';
import { codeColourId } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { CodeFieldWireKey, CodeFieldFlagWireKey } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const CodeColour = (props: CodeColourProps) => {

  const { metadata, codeItem, onChange, options, loadOptions, translation, validation, readOnly } = props;

  if (!metadata || metadata && !metadata.colourCode ||
    metadata && metadata.colourCode && !isDefinedIncludingZero(metadata.colourCode.id)) {
    return null;
  }

  const codetableId = !!metadata && !!metadata.codetable && isDefinedIncludingZero(metadata.codetable.id)
    ? metadata.codetable.id
    : undefined;

  const removeSiblingId = { siblingId: undefined };
  const removeLevels = { levels: undefined };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(
      id,
      endpoints.optionsCollectionSearch(codeColourId),
      {
        ...loadOptionsParams,
        requestApiMethod: RequestApiMethod.post,

        ...removeSiblingId,
        ...removeLevels,
        ...{ apiVersion: '3.0' }
      }, { limitFieldsTo: [CodeFieldWireKey.code, CodeFieldFlagWireKey.colour] });
  };

  const colourOptions = (!!options.colour && options.colour.codes || []) as CodeComplexValue<number>[];

  const colourCodeValidation = !!validation && !!validation.colourCode ? validation.colourCode : undefined;

  return <CodeSinglePicker
    id="colour"
    label={translation ? translation.colour : undefined}
    valueItem={codeItem && codeItem.colourCode}
    required={false}
    searchRequired={codetableId && metadata.codetable.searchRequired}
    readOnly={readOnly}
    showBackgroundColour={true}
    options={colourOptions}
    fetchingOptions={options.colour && options.colour.fetching}

    translation={translation}
    validation={colourCodeValidation}

    onLoadOptions={onLoadOptions}
    onChange={onChange}
  />;
};
